import { basicColors, retroColors, electricColors } from "style/basic/basicColors";
export const CommonFormStyle = {
  formStyle: {
    default: {},
    retro: {
      backgroundColor: "var(--nine)",
    },
    electric: {
      backgroundColor: electricColors.nine,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/SetupPage/User/UserForm/style/index.js